import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { BASE_API_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const musicArtistSongpageApi = createApi({
  reducerPath: 'musicArtistSongpageApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_API_URL + 'music' ,
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('musicArtistSongpageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchMusicArtistSongData: builder.query({
      query: (option) => ({
        url : 'artist/song',
        method: 'POST',
        body : {
            "phone": "",
            "platform": "miniapp",
            "udid": "190740e5f0032702",
            "user_id": getLocalStorageData(),
            "version_code": 20,
            "version_name": "1.2.9",
            "artist_id" : option.artist_id
        },
      }), 
    })
  }),
});

export const { useFetchMusicArtistSongDataQuery, endpoints } = musicArtistSongpageApi;